import { render, staticRenderFns } from "./two-factor-auth.vue?vue&type=template&id=09a7e842"
import script from "./two-factor-auth.vue?vue&type=script&lang=js"
export * from "./two-factor-auth.vue?vue&type=script&lang=js"
import style0 from "./two-factor-auth.vue?vue&type=style&index=0&id=09a7e842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports